/** Shared auth fields for student/parent support API calls (matches Diary and other portal APIs). */
export function getStudentSupportApiPayload(extra = {}) {
  const studentId = parseInt(localStorage.getItem("ID"), 10) || 0;
  return {
    AccessKey: localStorage.getItem("AccessKey"),
    UserID: studentId,
    Student_ID: studentId,
    MemberType: localStorage.getItem("MemberType") || "Student",
    ...extra,
  };
}

export function getSupportApiErrorMessage(err) {
  if (err?.response?.data?.status_message) {
    return err.response.data.status_message;
  }
  if (err?.response?.status === 404) {
    return "Support API not found. Rebuild and restart the API project.";
  }
  if (err?.message) {
    return err.message;
  }
  return "Network error.";
}
